import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description =
  '現場DXサービス「KANNA」を運営するアルダグラムが、デザインと実装のズレやコンポーネント乱立を解消するためデザインシステムを構築した事例。要件定義とテンプレート伴走で、内製・自走できる仕組みづくりをアイスリーデザインが支援しました。'

const primaryImage = `${SITE_URL}/images/img/cases/aldagram/ogp_aldagram.png`

/** HeadMeta と JSON-LD で共有するメタ情報 */
export const aldagramPageMeta: PageMeta = {
  title: '株式会社アルダグラム｜AI時代の開発生産性を支えるデザインシステムを構築｜事例｜i3DESIGN アイスリーデザイン',
  description,
  keyword: '事例 実績 デザインシステム UI/UX アルダグラム KANNA',
  image: primaryImage,
  url: `${SITE_URL}/cases/aldagram/`,
}

export const aldagramSchema = buildCaseStudySchema({
  slug: 'aldagram',
  pageTitle: aldagramPageMeta.title,
  description: aldagramPageMeta.description,
  headline: 'AI時代の開発生産性を支えるデザインシステムを構築',
  alternativeHeadline: '株式会社アルダグラム',
  primaryImage,
  images: [primaryImage, `${SITE_URL}/images/img/cases/aldagram/mv.webp`],
  clientName: '株式会社アルダグラム',
  breadcrumbLabel: 'AI時代の開発生産性を支えるデザインシステムを構築',
})
